import React, { forwardRef } from 'react'

import { TTextProps, Text } from './Text'

export type TPProps = TTextProps

export const P = forwardRef<HTMLParagraphElement, TPProps>(({ as = 'p', block = true, ...props }, ref) => (
  <Text {...{ as, block }} {...props} ref={ref} />
))

P.displayName = 'P'
